import React, { useState,useEffect } from 'react'
import { getCurrentDate } from '../../Utils/Dateutils';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox
} from '@mui/material';
import TitleBar from '../TitleBar';
import { ReceiptMenu } from '../TitleList';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import RadioComponent from '../FieldsComponents/RadioComponent';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';

const Adv_RT_Settlement = () => {
 const [lumplist, setLumplist] = useState([]);
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        setType:'',
        setNo:'',
        firmId: '',
        rptNo: '',
        billNo: '',
        partyId: '',
        totAdvAmt: '',
        totPaidAmt: '',
        remAmt: '',
        narr: '',
        userId: userdata?.ID
    });

    const dispatch= useDispatch();
    const firmList= useSelector(selectFirm);
     
    useEffect(()=>{
        dispatch(fetchCompanyData());
    },[dispatch]);

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Receipt No.', name: 'rptNo', type: 'readOnly' }

    ];


    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const dropdownlistfirst = [
        {
            label: 'Firm Name',
            id: 'firmId',
            options: firmList?.data||[],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Emp. Name',
            id: 'empId',
            options: [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Bill No.',
            id: 'billNo',
            options: [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party',
            id: 'partyId',
            options: [],
            value: formData.empId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'partyId', value: newValue ? newValue.ID : '' } }, 'partyId'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };

    const fields01 = [

        { label: 'Total', name: 'total', type: 'readOnly' },
        { label: 'Total Paid Amt', name: 'totPaid', type: 'readOnly' },
        { label: 'Net Balance', name: 'netBal', type: 'readOnly' }

    ];

    const paymode = [

        { label: 'Cash', value: 'cash' },
        { label: 'Cheque', value: 'cheque' },
        { label: 'Online Pay', value: 'onlinepay' }
    ]
    const Amtfields = [
        { label: 'Paying Amt', name: 'payAmt' },
        { label: 'Balance Amount', name: 'balAmt', type: 'readOnly' }

    ];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };
 const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const handleCheckboxChange = (index) => {
        const updatedList = [...lumplist];
        updatedList[index].checked = !updatedList[index].checked;
        setLumplist(updatedList);
    };

    return (
        <>
            <TitleBar data={ReceiptMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Receipt Entry</h2>


                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {fields01.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}
                                <TextareaComponent
                                    label="Naration"
                                    name="narr"
                                    value={formData.narr}
                                    onChange={handleInputChange}
                                    isDesktop={isDesktop}
                                />
                                <RadioComponent
                                    label="Payment Mode:"
                                    name="payM"
                                    value={formData.payM}
                                    options={paymode}
                                    onChange={handleInputChange}
                                    isDesktop={true} // Pass the actual value based on screen size
                                />

                                {Amtfields.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}




                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                        <TableBody>

                                            <TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Receipt No.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Date</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Paid Amount</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Print</TableCell>
                                            </TableRow>

                                        </TableBody>


                                    </Table>
                                </TableContainer>




                            </Grid>

                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    )
}

export default Adv_RT_Settlement;
